import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, requireRole }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  // Force-password-change gate. Any authenticated route (except the
  // change-password screen itself) redirects here until the flag has
  // been cleared by /auth/change-password.
  if (user.force_password_change && loc.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  if (requireRole) {
    const roles = Array.isArray(requireRole) ? requireRole : [requireRole];
    const ok = roles.some((r) => {
      if (r === "admin") return user.role === "admin" || user.role === "super_admin";
      if (r === "organiser") return user.role === "organiser" || user.role === "admin" || user.role === "super_admin";
      return user.role === r;
    });
    if (!ok) return <Navigate to="/events" replace />;
  }
  return children;
}
